<div class="cabboton container p-3 my-3 bg-cabimp text-white">
    <button  class="btn btn-cave" (click)="volver()">
      <fa-icon [icon]="icoRet"></fa-icon>  Volver
    </button>
     <button style="margin-left:5px;" class="btn btn-success"  onClick="window.print()">
      <fa-icon [icon]="icoPrn"></fa-icon>  Imprimir
    </button>
</div>
<div style="text-align: center;">
  <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
</div>

<div class="cuerpo">
   <h2 class="heading" style="text-align: center;">ENTREGAS DE UVA </h2> 
   <h3 class="heading" style="text-align: center;">{{nomusu}} </h3> 

   <table id="tabla" class="table table-bordered row-border hover">
           <thead>
             <tr>
               <th >Fecha</th>
               <th >Clase de Uva</th>
               <th >Kilogramos</th>
               <th >Arrobas</th>
               <th >Grado</th>
               <th >Hectógrado</th>
               <th >Precio</th>
               <th >Importe</th>
             </tr>
           </thead> 
           <tbody>
             <tr *ngFor="let dato of datosTabla"> 
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}">{{ dato.enFecha }}</td>
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}">{{ dato.enUva }}</td> 
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}" class="numero">{{ dato.enKil | number}}</td>
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}" class="numero">{{ dato.enArb | number: '.2'}}</td>
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}" class="numero">{{ dato.enGrd | number: '.2'}}</td>
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}" class="numero">{{ dato.enHgr | number: '.4'}}</td>
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}" class="numero">{{ dato.enPre | number: '.3'}}</td>
               <td [ngClass]="{'sumas': dato.enFecha === ' Totales','stotal': dato.enUva === '   TOTALES'}" class="numero">{{ dato.enImp | number: '.2'}}</td> 
             </tr> 
           </tbody> 
   </table>
 
</div>





